import { registerPlugin } from '@capacitor/core'

const KeychainCookie = registerPlugin('KeychainCookie')

export default {
  async has (cookieName) {
    // console.log('RJMDEBUG400 IOS cookies has', cookieName)
    const result = await KeychainCookie.has({
      key: cookieName
    })

    return result.value
  },

  async get (cookieName) {
    // console.log('RJMDEBUG400 IOS cookies get', cookieName)
    const result = await KeychainCookie.get({
      key: cookieName
    })

    if (result.value === null || result.value === undefined) {
      return undefined
    }

    try {
      return JSON.parse(result.value)
    } catch {
      // Backwards compatibility for plain strings
      return result.value
    }
  },

  async set (cookieName, value) {
    // console.log('RJMDEBUG400 IOS cookies set', cookieName, value, typeof value)
    let storedValue

    if (value === undefined) {
      storedValue = JSON.stringify(null)
    } else {
      storedValue = JSON.stringify(value)
    }

    await KeychainCookie.set({
      key: cookieName,
      value: storedValue
    })
  },

  async remove (cookieName) {
    // console.log('RJMDEBUG400 IOS cookies remove', cookieName)
    await KeychainCookie.remove({
      key: cookieName
    })
  }
}
